import { useCallback, useState } from 'react';
// Here, we're intercepting navigate() while (for example) editing a dashboard
// eslint-disable-next-line react-portal/no-react-router-use-navigate
import { useBlocker, useNavigate } from 'react-router-dom';
import { t } from '@lingui/macro';
import NgpTwoButtonDialog from '../dialog-two-button/NgpTwoButtonDialog';

const defaultTitle = t`Leave Page?`;
const defaultMessage = t`Are you sure you want to leave this page?  Unsaved changes will be lost.`;

export function ConfirmNavigationDialog({ confirmWhen, title = defaultTitle, message = defaultMessage }) {
    const [open, setOpen] = useState(false);
    const [navDestination, setNavDestination] = useState();
    const navigate = useNavigate();

    const handleConfirmedNav = useCallback(() => {
        navigate(navDestination.location);
    }, [navDestination, navigate]);

    const handleBlockedNavigation = useCallback((nextLocation) => {
        setNavDestination(nextLocation);
        setOpen(true);
    }, []);

    // if the dialog is open, the only navigate() that should happen is from the user clicking "OK":
    useBlocker(handleBlockedNavigation, confirmWhen && !open);

    return (
        confirmWhen && (
            <NgpTwoButtonDialog
                title={title}
                open={open}
                setOpen={setOpen}
                onConfirm={handleConfirmedNav}
                isWarning
                closeInTitleBar={false}
            >
                <div>{message}</div>
            </NgpTwoButtonDialog>
        )
    );
}
